import { REFRIGERATOR_OPTIONS, SortRefrigeratorBy } from '@common/enums';
import { Filter } from '@common/models';
import { RootState } from '@redux/store';
import { PayloadAction, createSlice } from '@reduxjs/toolkit';

export type RefrigeratorFilters = Record<string, Filter>;
type RefrigeratorId = number;
export interface RefrigeratorState {
    selectedRefrigeratorId?: RefrigeratorId;
    inStoreRefrigeratorsUrl?: string;
    refrigeratorFilters?: RefrigeratorFilters;
    refrigeratorSelectedOption?: REFRIGERATOR_OPTIONS;
    sortBy?: SortRefrigeratorBy;
}

const initialState: RefrigeratorState = {
    inStoreRefrigeratorsUrl: undefined,
    refrigeratorFilters: undefined,
    refrigeratorSelectedOption: undefined,
    sortBy: undefined,
    selectedRefrigeratorId: undefined,
};

const refrigeratorSlice = createSlice({
    name: 'refrigerator',
    initialState,
    reducers: {
        updateSelectedRefrigeratorId: (state, action: PayloadAction<RefrigeratorId>) => {
            state.selectedRefrigeratorId = action.payload;
        },
        updateSelectedRefrigerator: (state, action: PayloadAction<REFRIGERATOR_OPTIONS | undefined>) => {
            state.refrigeratorSelectedOption = action.payload;
        },
        updateInStoreRefrigeratorsUrl: (state, action: PayloadAction<string>) => {
            state.inStoreRefrigeratorsUrl = action.payload;
        },
        updateRefrigeratorsFilters: (state, action: PayloadAction<RefrigeratorFilters>) => {
            state.refrigeratorFilters = action.payload;
        },
        resetRefrigerators: (state) => {
            state.refrigeratorFilters = initialState.refrigeratorFilters;
            state.refrigeratorSelectedOption = initialState.refrigeratorSelectedOption;
        },
        updateRefrigeratorsSortBy: (state, action: PayloadAction<SortRefrigeratorBy | undefined>) => {
            state.sortBy = action.payload;
        },
    },
});

export const {
    updateSelectedRefrigerator,
    updateInStoreRefrigeratorsUrl,
    updateRefrigeratorsFilters,
    resetRefrigerators,
    updateRefrigeratorsSortBy,
    updateSelectedRefrigeratorId,
} = refrigeratorSlice.actions;

export default refrigeratorSlice.reducer;

export const selectInStoreRefrigeratorsUrl = ({ refrigerator }: RootState): string | undefined =>
    refrigerator.inStoreRefrigeratorsUrl;

export const selectRefrigeratorFilters = ({ refrigerator }: RootState): RefrigeratorFilters | undefined =>
    refrigerator.refrigeratorFilters;

export const selectSelectedRefrigeratorId = ({ refrigerator }: RootState): RefrigeratorId | undefined =>
    refrigerator.selectedRefrigeratorId;

export const selectRefrigeratorSelectedOption = ({ refrigerator }: RootState): REFRIGERATOR_OPTIONS | undefined =>
    refrigerator.refrigeratorSelectedOption;

export const selectRefrigeratorFiltersSortBy = ({ refrigerator }: RootState): SortRefrigeratorBy | undefined =>
    refrigerator.sortBy;
